export default __webpack_public_path__ + "static/vermiculite-b057871c686a812f424f9eac82a347b8.jpg";